<style lang="scss">
/* ===== PC Layout Container ===== */
.page-inner {
  max-width: 1200px;
  margin: 0 auto;
}

/* ===== Modal Width Override ===== */
:deep(.ant-modal) {
  max-width: none !important;
}

/* ===== Stat Cards ===== */
.stat-row {
  margin-bottom: 12px;
}

.stat-card {
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }

  :deep(.ant-card-body) {
    padding: 16px 20px;
  }
}

.stat-inner {
  display: flex;
  align-items: center;
  gap: 14px;
}

.stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;

  &.stat-icon-blue {
    background: linear-gradient(135deg, #e6f4ff, #bae0ff);
    color: #1677ff;
  }

  &.stat-icon-green {
    background: linear-gradient(135deg, #f6ffed, #d9f7be);
    color: #52c41a;
  }

  &.stat-icon-orange {
    background: linear-gradient(135deg, #fff7e6, #ffd591);
    color: #fa8c16;
  }

  &.stat-icon-purple {
    background: linear-gradient(135deg, #f9f0ff, #d3adf7);
    color: #722ed1;
  }
}

.stat-info {
  flex: 1;
  min-width: 0;
}

.stat-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 2px;
}

.stat-value {
  font-size: 22px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
  line-height: 1.2;

  &.stat-value-sm {
    font-size: 18px;
  }
}

.stat-actions {
  margin-top: 2px;
  display: flex;
  align-items: center;
}

/* ===== Info Cards ===== */
.info-row {
  margin-bottom: 12px;
}

.info-card {
  border-radius: 8px;
  height: 100%;

  :deep(.ant-card-head) {
    border-bottom: 1px solid #f0f0f0;
    padding: 0 14px;
    min-height: 42px;
  }

  :deep(.ant-card-head-title) {
    font-weight: 600;
    font-size: 13px;
  }

  :deep(.ant-card-body) {
    padding: 12px 14px;
  }

  :deep(.ant-form-item) {
    margin-bottom: 10px;
  }

  :deep(.ant-form-item-label > label) {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
  }
}

/* ===== QR Upload ===== */
.qr-upload-item {
  text-align: center;
}

.qr-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.qr-uploader {
  display: block;

  :deep(.ant-upload) {
    display: flex;
    justify-content: center;
  }
}

.qr-preview {
  width: 88px;
  height: 88px;
  border-radius: 10px;
  object-fit: cover;
  border: 1px solid #f0f0f0;
}

.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  border: 1px dashed #d9d9d9;
  border-radius: 10px;
  background: #fafafa;
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    border-color: #1677ff;
    color: #1677ff;
  }

  .qr-plus {
    font-size: 20px;
    margin-bottom: 2px;
  }

  span {
    font-size: 11px;
  }
}

/* ===== Table Card ===== */
.table-card {
  border-radius: 8px;

  :deep(.ant-card-head) {
    border-bottom: 1px solid #f0f0f0;
    padding: 0 16px;
    min-height: 48px;
  }

  :deep(.ant-card-body) {
    padding: 0 16px 16px;
  }
}

.card-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-title-text {
  font-weight: 600;
  font-size: 14px;
}

.card-title-sub {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-weight: normal;
}

/* ===== Table Toolbar ===== */
.table-toolbar {
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 0;
}

/* ===== Plugin Cell ===== */
.plugin-cell {
  .plugin-name {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.88);
    font-size: 13px;
  }

  .plugin-icon {
    color: #1677ff;
    font-size: 14px;
  }

  .plugin-sub {
    margin-top: 3px;
  }
}

/* ===== PC vs Mobile Toggle ===== */
.auth-card-list,
.auth-mobile-empty {
  display: none;
}

.auth-card-list {
  display: none;
  gap: 12px;

  .auth-mobile-card {
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

    :deep(.ant-card-body) {
      padding: 12px 14px;
    }
  }

  .auth-mobile-card.row-expired {
    background: #fff1f0;
  }

  .auth-mobile-card.row-warning {
    background: #fffbe6;
  }

  .mobile-card-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
  }

  .mobile-card-title {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.88);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
  }

  .mobile-card-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 10px;
  }

  .mobile-field {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
  }

  .mobile-label {
    color: rgba(0, 0, 0, 0.45);
    min-width: 56px;
    flex-shrink: 0;
    font-size: 12px;
  }

  .mobile-value {
    color: rgba(0, 0, 0, 0.88);
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mobile-card-foot {
    display: flex;
    gap: 8px;
    padding-top: 8px;
    border-top: 1px solid #f5f5f5;
  }
}

/* ===== Expired/Warning Row ===== */
:deep(.row-expired)>td {
  background: #fff1f0 !important;
}

:deep(.row-expired:hover)>td {
  background: #ffccc7 !important;
}

:deep(.row-warning)>td {
  background: #fffbe6 !important;
}

:deep(.row-warning:hover)>td {
  background: #fff1b8 !important;
}

/* ===== Batch Bar ===== */
.table-batch-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background: #e6f4ff;
  border-radius: 0 0 8px 8px;
  margin-top: 0;
  border-top: 1px solid #bae0ff;

  strong {
    color: #1677ff;
    font-size: 13px;
  }
}

/* ===== Table Pagination ===== */
.table-pagination {
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;
}

/* ===== Modify Count ===== */
.modify-count {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 8px;
  font-size: 12px;
  font-weight: 500;
  color: #1677ff;
  background: #e6f4ff;
  border-radius: 10px;
  cursor: help;

  &.modify-count-zero {
    color: rgba(0, 0, 0, 0.45);
    background: #f5f5f5;
  }

  .tip-icon {
    font-size: 11px;
  }
}

/* ===== History ===== */
.history-alert {
  margin-bottom: 12px;
}

.host-old {
  color: #ff4d4f;
  text-decoration: line-through;
}

.host-new {
  color: #52c41a;
  font-weight: 500;
}

.empower-total {
  margin-top: 8px;
}

.unit-text {
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
}

/* ===== Mobile Responsive ===== */
@media screen and (max-width: 768px) {

  /* ===== PC vs Mobile Toggle ===== */
  .auth-table-pc,
  .table-batch-bar,
  .table-pagination {
    display: none !important;
  }

  .auth-card-list,
  .auth-mobile-empty {
    display: flex !important;
  }

  .auth-card-list {
    flex-direction: column;
  }

  /* Layout */
  .ant-layout-content {
    padding: 12px !important;
  }

  /* Stat Cards - 2 cols */
  .stat-row {
    margin-bottom: 8px;
  }

  .stat-card :deep(.ant-card-body) {
    padding: 12px 14px;
  }

  .stat-inner {
    gap: 10px;
  }

  .stat-icon {
    width: 36px;
    height: 36px;
    font-size: 16px;
    border-radius: 8px;
  }

  .stat-label {
    font-size: 11px;
  }

  .stat-value {
    font-size: 18px;

    &.stat-value-sm {
      font-size: 15px;
    }
  }

  .stat-actions {
    flex-wrap: wrap;
  }

  /* Info Cards - stack */
  .info-row {
    margin-bottom: 8px;
  }

  .info-card :deep(.ant-card-head) {
    padding: 0 12px;
    min-height: 44px;
  }

  .info-card :deep(.ant-card-head-title) {
    font-size: 13px;
  }

  .info-card :deep(.ant-card-body) {
    padding: 12px;
  }

  /* QR - smaller */
  .qr-preview {
    width: 80px;
    height: 80px;
  }

  .qr-placeholder {
    width: 80px;
    height: 80px;

    .qr-plus {
      font-size: 18px;
    }

    span {
      font-size: 10px;
    }
  }

  /* Table Card */
  .table-card :deep(.ant-card-head) {
    padding: 0 12px;
    min-height: 44px;
  }

  .table-card :deep(.ant-card-body) {
    padding: 0 12px 12px;
  }

  /* Toolbar - tighter */
  .table-toolbar {
    padding: 10px 12px;
  }

  /* Table - dense mobile mode */
  .table-card :deep(.ant-table) {
    .ant-table-thead>tr>th {
      padding: 6px 8px !important;
      font-size: 11px;
    }

    .ant-table-tbody>tr>td {
      padding: 4px 8px !important;
      font-size: 12px;
    }

    .ant-table-cell {
      padding: 4px 8px !important;
    }
  }

  .modify-count {
    padding: 0 6px;
    font-size: 11px;
  }

  /* Pagination */
  .table-pagination {
    padding-top: 8px;

    :deep(.ant-pagination) {
      font-size: 12px;

      .ant-pagination-item {
        min-width: 28px;
        height: 28px;
        line-height: 28px;
      }
    }
  }

  /* Card title row */
  .card-title-row {
    gap: 8px;
    flex-wrap: wrap;
  }

  .card-title-text {
    font-size: 13px;
  }

  /* Batch bar */
  .table-batch-bar {
    padding: 8px 12px;
    font-size: 12px;
  }
}

/* Very small phones */
@media screen and (max-width: 480px) {
  .ant-layout-content {
    padding: 8px !important;
  }

  .stat-card :deep(.ant-card-body) {
    padding: 10px 12px;
  }

  .stat-icon {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .stat-value {
    font-size: 16px;

    &.stat-value-sm {
      font-size: 14px;
    }
  }

  .table-card :deep(.ant-table) {
    .ant-table-thead>tr>th {
      padding: 4px 6px !important;
      font-size: 10px;
    }

    .ant-table-tbody>tr>td {
      padding: 3px 6px !important;
      font-size: 11px;
    }

    .ant-table-cell {
      padding: 3px 6px !important;
    }
  }
}
</style><template>
  <a-layout style="min-height: 100vh;">
    <UserHead />
    <a-layout>
      <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
        <HeadTop />
      </a-layout-header>
      <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
        <div class="page-inner">
          <!-- 顶部统计卡片 -->
          <a-row :gutter="[16, 16]" class="stat-row">
            <a-col :xs="24" :sm="12" :md="6">
              <a-card class="stat-card stat-card-primary" :bordered="false">
                <div class="stat-inner">
                  <div class="stat-icon stat-icon-blue">
                    <WalletOutlined />
                  </div>
                  <div class="stat-info">
                    <div class="stat-label">我的余额</div>
                    <div class="stat-value">
                      <a-statistic :value="user_conf.money" :precision="2" prefix="¥" />
                    </div>
                    <div class="stat-actions">
                      <a-button type="link" size="small" @click="puy_money()">在线充值</a-button>
                      <a-divider type="vertical" />
                      <a-button type="link" size="small" @click="withdrawalView()">提现</a-button>
                    </div>
                  </div>
                </div>
              </a-card>
            </a-col>
            <a-col :xs="24" :sm="12" :md="6">
              <a-card class="stat-card" :bordered="false">
                <div class="stat-inner">
                  <div class="stat-icon stat-icon-green">
                    <UserOutlined />
                  </div>
                  <div class="stat-info">
                    <div class="stat-label">用户编号</div>
                    <div class="stat-value stat-value-sm">{{ user_conf.uid }}</div>
                  </div>
                </div>
              </a-card>
            </a-col>
            <a-col :xs="24" :sm="12" :md="6">
              <a-card class="stat-card" :bordered="false">
                <div class="stat-inner">
                  <div class="stat-icon stat-icon-orange">
                    <CrownOutlined />
                  </div>
                  <div class="stat-info">
                    <div class="stat-label">当前等级</div>
                    <div class="stat-value stat-value-sm">{{ user_conf.grade_name || '普通用户' }}</div>
                  </div>
                </div>
              </a-card>
            </a-col>
            <a-col :xs="24" :sm="12" :md="6">
              <a-card class="stat-card" :bordered="false">
                <div class="stat-inner">
                  <div class="stat-icon stat-icon-purple">
                    <TeamOutlined />
                  </div>
                  <div class="stat-info">
                    <div class="stat-label">上级代理</div>
                    <div class="stat-value stat-value-sm">{{ user_conf.higher_uid || '无' }}</div>
                  </div>
                </div>
              </a-card>
            </a-col>
          </a-row>

          <!-- 用户信息 + 收款信息 -->
          <a-row :gutter="[16, 16]" class="info-row">
            <a-col :xs="24" :lg="14">
              <a-card title="用户信息管理" :bordered="false" class="info-card">
                <a-form :model="user_conf" layout="horizontal" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
                  <a-form-item label="用户编号">
                    <a-input :value="user_conf.uid" disabled />
                  </a-form-item>
                  <a-form-item label="用户名">
                    <a-input v-model:value="user_conf.username" placeholder="请输入用户名" />
                  </a-form-item>
                  <a-form-item label="我的上级">
                    <a-input :value="user_conf.higher_uid" disabled />
                  </a-form-item>
                  <a-form-item label="绑定邮箱">
                    <a-input :value="user_conf.user_email" disabled />
                  </a-form-item>
                  <a-form-item label="登录密码">
                    <a-input-password v-model:value="user_conf.password" placeholder="请输入新密码" />
                  </a-form-item>
                  <a-form-item :wrapper-col="{ offset: 5, span: 14 }">
                    <a-button type="primary" @click="openDialog('消息', '您确认要修改用户信息吗', true, 'setUserInfo')">
                      保存修改
                    </a-button>
                  </a-form-item>
                </a-form>
              </a-card>
            </a-col>
            <a-col :xs="24" :lg="10">
              <a-card title="收款信息管理" :bordered="false" class="info-card">
                <a-row :gutter="[16, 16]">
                  <a-col :span="12">
                    <div class="qr-upload-item">
                      <div class="qr-label">
                        <WechatOutlined /> 微信收款码
                      </div>
                      <a-upload :show-upload-list="false" class="qr-uploader" :action="upload.url"
                        :data="upload.wx_data" :before-upload="beforeAvatarUpload" @change="handleWxUploadChange">
                        <a-image v-if="!isNull(user_conf.wxQR_code)" :src="user_conf.wxQR_code" fit="cover"
                          class="qr-preview" />
                        <div v-else class="qr-placeholder">
                          <PlusOutlined class="qr-plus" />
                          <span>上传微信码</span>
                        </div>
                      </a-upload>
                    </div>
                  </a-col>
                  <a-col :span="12">
                    <div class="qr-upload-item">
                      <div class="qr-label">
                        <AlipayCircleOutlined /> 支付宝收款码
                      </div>
                      <a-upload :show-upload-list="false" class="qr-uploader" :action="upload.url"
                        :data="upload.zfb_data" :before-upload="beforeAvatarUpload" @change="handleZfbUploadChange">
                        <a-image v-if="!isNull(user_conf.zfbQR_code)" :src="user_conf.zfbQR_code" fit="cover"
                          class="qr-preview" />
                        <div v-else class="qr-placeholder">
                          <PlusOutlined class="qr-plus" />
                          <span>上传支付宝码</span>
                        </div>
                      </a-upload>
                    </div>
                  </a-col>
                </a-row>
              </a-card>
            </a-col>
          </a-row>

          <!-- 授权列表 -->
          <a-card :bordered="false" class="table-card">
            <template #title>
              <div class="card-title-row">
                <span class="card-title-text">我的授权列表</span>
                <a-tag color="blue">{{ empower_Conf.total }} 条</a-tag>
              </div>
            </template>
            <template #extra>
              <a-button type="primary" @click="addEmpowerFun('dialog')">
                <template #icon>
                  <PlusOutlined />
                </template>添加授权
              </a-button>
            </template>

            <a-table class="auth-table-pc" :data-source="empower_data" :pagination="false" row-key="empower_id"
              :scroll="{ x: 1140 }" size="small" :loading="empowerLoading" bordered :columns="empowerColumns"
              :row-class-name="getEmpowerRowClass">
              <template #bodyCell="{ column, record }">
                <!-- 插件名 + 版本 -->
                <template v-if="column.key === 'includes_name'">
                  <div class="plugin-cell">
                    <div class="plugin-name">
                      <AppstoreOutlined class="plugin-icon" />
                      {{ record.includes_name }}
                    </div>
                    <div class="plugin-sub">
                      <a-tag color="blue" style="margin: 0;">v{{ record.version_name }}</a-tag>
                    </div>
                  </div>
                </template>

                <!-- 授权字段（域名） -->
                <template v-else-if="column.key === 'host'">
                  <a-input v-model:value="record.empower_host" size="small" @focus="cacheOrigin(record, 'host')"
                    @blur="updateHostClick(record)" placeholder="请输入域名/IP">
                    <template #addonBefore>
                      <GlobalOutlined />
                    </template>
                  </a-input>
                </template>

                <!-- 修改次数 -->
                <template v-else-if="column.key === 'modify_count'">
                  <a-tooltip placement="top" title="1.每月可免费修改授权次数有限，2.每个授权总共的免费修改次数有限，超出后可付费修改（从余额扣除）">
                    <span class="modify-count" :class="{ 'modify-count-zero': !record.modify_count }">
                      <EditOutlined class="tip-icon" />
                      {{ record.modify_count || 0 }} 次
                    </span>
                  </a-tooltip>
                </template>

                <!-- 历史记录 -->
                <template v-else-if="column.key === 'modify_history'">
                  <a-button size="small" type="link" :disabled="!record.modify_history"
                    @click="openHistoryDialog(record)">
                    <template #icon>
                      <HistoryOutlined />
                    </template>
                    {{ parseHistory(record.modify_history).length }} 条
                  </a-button>
                </template>

                <!-- 到期时间 -->
                <template v-else-if="column.key === 'end_date'">
                  <a-tooltip v-if="getEndDateColor(record.end_date) === 1" :title="'到期: ' + record.end_date">
                    <a-tag color="green">
                      <ClockCircleOutlined /> {{ record.end_date }}
                    </a-tag>
                  </a-tooltip>
                  <a-tooltip v-else-if="getEndDateColor(record.end_date) === 2" :title="'即将到期! 剩余3天内'">
                    <a-tag color="gold">
                      <WarningOutlined /> {{ record.end_date }}
                    </a-tag>
                  </a-tooltip>
                  <a-tooltip v-else :title="'已过期，建议尽快续费或删除'">
                    <a-tag color="red">
                      <CloseCircleOutlined /> {{ record.end_date }}
                    </a-tag>
                  </a-tooltip>
                </template>

                <!-- 备注 -->
                <template v-else-if="column.key === 'remark'">
                  <a-input v-model:value="record.remark" size="small" @focus="cacheOrigin(record, 'remark')"
                    @blur="updateRemarkClick(record)" placeholder="备注" />
                </template>

                <!-- 操作 -->
                <template v-else-if="column.key === 'action'">
                  <a-space size="small">
                    <a-button type="link" size="small"
                      @click="renewAuthDialog(record.empower_id, record.includes_id, record.version)">
                      <template #icon>
                        <ReloadOutlined />
                      </template>续费
                    </a-button>
                    <a-dropdown v-if="getEndDateColor(record.end_date) === 3 || record.is_free == 1">
                      <a-button type="link" size="small">
                        更多
                        <DownOutlined />
                      </a-button>
                      <template #overlay>
                        <a-menu>
                          <a-menu-item key="delete" danger @click="deleteAuthDialog(record.empower_id)">
                            <DeleteOutlined /> 删除授权
                          </a-menu-item>
                        </a-menu>
                      </template>
                    </a-dropdown>
                  </a-space>
                </template>
              </template>
            </a-table>

            <!-- 手机端卡片列表 -->
            <div class="auth-card-list" v-if="empower_data && empower_data.length > 0">
              <a-card v-for="record in empower_data" :key="record.empower_id" class="auth-mobile-card" :bordered="false"
                :class="getEmpowerRowClass(record)">
                <div class="mobile-card-head">
                  <div class="mobile-card-title">
                    <AppstoreOutlined style="color: #1677ff; margin-right: 6px;" />
                    {{ record.includes_name }}
                    <a-tag color="blue" style="margin-left: 6px;">v{{ record.version_name }}</a-tag>
                  </div>
                  <a-tag v-if="getEndDateColor(record.end_date) === 1" color="green">
                    <ClockCircleOutlined /> 正常
                  </a-tag>
                  <a-tag v-else-if="getEndDateColor(record.end_date) === 2" color="gold">
                    <WarningOutlined /> 即将到期
                  </a-tag>
                  <a-tag v-else color="red">
                    <CloseCircleOutlined /> 已过期
                  </a-tag>
                </div>
                <div class="mobile-card-body">
                  <div class="mobile-field">
                    <span class="mobile-label">插件ID</span>
                    <span class="mobile-value">{{ record.includes_id }}</span>
                  </div>
                  <div class="mobile-field">
                    <span class="mobile-label">授权字段</span>
                    <a-input v-model:value="record.empower_host" size="small" @focus="cacheOrigin(record, 'host')"
                      @blur="updateHostClick(record)" placeholder="域名/IP" style="flex: 1;" />
                  </div>
                  <div class="mobile-field">
                    <span class="mobile-label">到期时间</span>
                    <span class="mobile-value">{{ record.end_date }}</span>
                  </div>
                  <div class="mobile-field">
                    <span class="mobile-label">修改次数</span>
                    <span class="modify-count" :class="{ 'modify-count-zero': !record.modify_count }">
                      {{ record.modify_count || 0 }} 次
                    </span>
                    <a-button size="small" type="link" :disabled="!record.modify_history"
                      @click="openHistoryDialog(record)">
                      <HistoryOutlined /> {{ parseHistory(record.modify_history).length }} 条
                    </a-button>
                  </div>
                  <div class="mobile-field">
                    <span class="mobile-label">备注</span>
                    <a-input v-model:value="record.remark" size="small" @focus="cacheOrigin(record, 'remark')"
                      @blur="updateRemarkClick(record)" placeholder="点击添加备注" style="flex: 1;" />
                  </div>
                </div>
                <div class="mobile-card-foot">
                  <a-button type="primary" size="small"
                    @click="renewAuthDialog(record.empower_id, record.includes_id, record.version)">
                    <ReloadOutlined /> 续费
                  </a-button>
                  <a-button size="small" v-if="getEndDateColor(record.end_date) === 3 || record.is_free == 1"
                    @click="deleteAuthDialog(record.empower_id)">
                    <DeleteOutlined /> 删除
                  </a-button>
                </div>
              </a-card>
            </div>

            <!-- 空状态（手机端） -->
            <a-empty v-if="(!empower_data || empower_data.length === 0) && !empower_Conf.disabled"
              class="auth-mobile-empty" description="暂无授权数据" />

            <!-- 分页 -->
            <div class="table-pagination">
              <a-pagination v-model:current="empower_Conf.currentPage" v-model:page-size="empower_Conf.pageSize"
                :page-size-options="[10, 25, 50]" :disabled="empower_Conf.disabled" show-size-changer show-quick-jumper
                :show-total="(total) => `共 ${total} 条记录`" :total="empower_Conf.total" @change="pageChange" />
            </div>
          </a-card>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>

  <!-- 通用确认对话框 -->
  <a-modal :mask-closable="false" v-model:open="centerDialog.isShow" :title="centerDialog.title" :width="560" centered>
    <a-alert type="warning" show-icon :message="centerDialog.content" />
    <template #footer>
      <a-button @click="centerDialog.isShow = false">取消</a-button>
      <a-button type="primary" @click="centerDialogClick(centerDialog.clickBind)">确认</a-button>
    </template>
  </a-modal>

  <!-- 历史修改记录 -->
  <a-modal :mask-closable="true" v-model:open="historyDialog.isShow" title="授权修改历史" :width="720" centered>
    <a-alert type="info" show-icon class="history-alert">
      <template #message>
        1.每月可免费修改授权次数有限，2.每个授权累计的免费修改次数有限，超出后可付费修改（从余额扣除）
      </template>
    </a-alert>
    <a-table :data-source="historyDialog.list" :pagination="false" row-key="time" size="small">
      <a-table-column type="index" label="序号" width="60" align="center" />
      <a-table-column data-index="old_host" label="修改前" :width="160">
        <template #bodyCell="{ record }">
          <span class="host-old">{{ record.old_host }}</span>
        </template>
      </a-table-column>
      <a-table-column data-index="new_host" label="修改后" :width="160">
        <template #bodyCell="{ record }">
          <span class="host-new">{{ record.new_host }}</span>
        </template>
      </a-table-column>
      <a-table-column label="类型" width="80" align="center">
        <template #bodyCell="{ record }">
          <a-tag :color="record.is_paid == 1 ? 'blue' : 'default'">
            {{ record.is_paid == 1 ? '付费' : '免费' }}
          </a-tag>
        </template>
      </a-table-column>
      <a-table-column data-index="time" label="修改时间" width="180" align="center" />
    </a-table>
    <a-empty v-if="historyDialog.list.length === 0" description="暂无历史修改记录" />
    <template #footer>
      <a-button type="primary" @click="historyDialog.isShow = false">关闭</a-button>
    </template>
  </a-modal>

  <!-- 升级等级 -->
  <a-modal :mask-closable="false" v-model:open="trendsDialog.dialogVisible" title="选择等级" :width="560" centered>
    <a-form layout="vertical">
      <a-form-item label="升级等级">
        <a-select v-model:value="select_option" placeholder="请选择需要升级的等级">
          <a-select-option v-for="(item) in grade_Option" :key="item.grade_id" :value="item.grade_id">{{ item.name +
            '---'
            + item.price_diff + '元' }}</a-select-option>
          <a-select-option v-if="grade_Option.length == 0" disabled>您已经是最高等级了</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button @click="trendsDialog.dialogVisible = false">关闭</a-button>
      <a-button type="primary" @click="centerDialogClick('gradeUp')">确认升级</a-button>
    </template>
  </a-modal>

  <!-- 添加/续费授权 -->
  <a-modal :mask-closable="false" v-model:open="addEmpower_dialog.dialogVisible" :title="addEmpower_dialog.title"
    centered :width="720">
    <a-form layout="vertical">
      <a-form-item v-show="!appConf.isRenew" label="授权插件">
        <a-select v-model:value="includes_data.select_option" @change="getPluginVersions" placeholder="请选择插件">
          <a-select-option v-for="(item) in includes_data.includes_list" :key="item.id" :value="item.id">{{ item.id +
            '---' + item.platform + '---' + item.name }}</a-select-option>
          <a-select-option v-if="includes_data.includes_list.length == 0" disabled>--暂无插件/您不是任何插件的代理--</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item v-show="!appConf.isRenew" label="功能版本">
        <a-select v-model:value="version_data.select_option" @change="onVersionChange" placeholder="请选择功能版本"
          :disabled="version_data.version_list.length === 0">
          <a-select-option v-for="(item) in version_data.version_list" :key="item.version" :value="item.version">{{
            item.version + '--' + item.versionName }}</a-select-option>
          <a-select-option v-if="version_data.version_list.length === 0 && includes_data.select_option"
            disabled>--该插件无版本信息--</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="授权时长单位">
        <a-select v-model:value="time_meal_data.select_option" @change="setTimeMeal(time_meal_data.select_option)"
          placeholder="请选择时长单位" :disabled="time_meal_data.time_meal_list.length === 0">
          <a-select-option v-for="(item) in time_meal_data.time_meal_list" :key="item.meal_id" :value="item.meal_id">{{
            item.time_unit + '---每' + item.time_unit + ' ' + item.price + '元' }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="授权时长">
        <a-input-number v-model:value="time_meal_data.num" :min="time_meal_data.min" :max="time_meal_data.max" />
        <span v-if="time_meal_data.unit != ''" class="unit-text" style="margin-left: 8px;">{{ time_meal_data.unit
        }}</span>
      </a-form-item>
      <a-form-item v-show="!appConf.isRenew" label="绑定邮箱">
        <a-input v-model:value="addEmpower_dialog.user_email" placeholder="若是普通用户则填写当前绑定邮箱" />
      </a-form-item>
      <a-form-item v-show="!appConf.isRenew" label="授权字段(域名/ip等)">
        <a-input v-model:value="addEmpower_dialog.host" placeholder="请输入域名或IP" />
      </a-form-item>
      <a-alert v-if="time_meal_data.unit != ''" class="empower-total" show-icon type="info">
        <template #message>总计: <strong style="color: #ff4d4f;">{{ getTimePrice }}</strong> 元</template>
      </a-alert>
    </a-form>
    <template #footer>
      <a-button @click="addEmpower_dialog.dialogVisible = false">关闭</a-button>
      <a-button type="primary" v-show="!appConf.isRenew"
        @click="openDialog('消息', '您确定要添加此授权吗？您需要支付' + getTimePrice + '元', true, 'addEmpower')">
        添加授权
      </a-button>
      <a-button type="primary" v-show="appConf.isRenew"
        @click="openDialog('消息', '您确定要续费此授权吗？您需要支付' + getTimePrice + '元', true, 'renewEmpower')">
        续费授权
      </a-button>
    </template>
  </a-modal>

  <!-- 充值对话框 -->
  <a-modal v-model:open="balanceRechargeDialog.isShow" title="账户充值" :width="560" centered :mask-closable="true">
    <a-form layout="vertical">
      <a-form-item label="充值金额">
        <a-input-number :min="balanceRechargeDialog.checkType.min" :max="balanceRechargeDialog.checkType.max"
          v-model:value="balanceRechargeDialog.money" style="width: 100%;" :precision="2"
          :placeholder="'单笔充值范围:' + balanceRechargeDialog.checkType.min + '--' + balanceRechargeDialog.checkType.max" />
      </a-form-item>
      <a-form-item label="支付方式">
        <a-select v-model:value="balanceRechargeDialog.type" placeholder="请选择支付方式" @change="payTypeChange">
          <a-select-option v-for="item in balanceRechargeDialog.types" :key="item.type" :value="item.type">{{ item.name
            +
            '(手续费' + item.fee + ')' }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button @click="balanceRechargeDialog.isShow = false">取消</a-button>
      <a-button type="primary" @click="toRecharge()">确认充值</a-button>
    </template>
  </a-modal>
</template>

<script lang="ts" setup>
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { ref, onMounted, reactive, computed, getCurrentInstance } from 'vue';
import { isNull, getEmpower, EmpowerResponse } from '@/utils/publicMethods';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { message, Modal } from 'ant-design-vue'
import { Grade } from '@/types/gradeInterface'
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'
import { PlusOutlined, QuestionCircleOutlined, InfoCircleOutlined, WalletOutlined, UserOutlined, CrownOutlined, TeamOutlined, WechatOutlined, AlipayCircleOutlined, AppstoreOutlined, GlobalOutlined, EditOutlined, HistoryOutlined, ClockCircleOutlined, WarningOutlined, CloseCircleOutlined, ReloadOutlined, DownOutlined, DeleteOutlined } from '@ant-design/icons-vue';

// 全局注册的图标（QuestionFilled 已全局注册）
const QuestionFilled = QuestionCircleOutlined;
const InfoFilled = InfoCircleOutlined;

const baseURL = process.env.VUE_APP_API_BASE_URL;

var labelPosition = 'right'
var user_conf = ref({
  uid: '',
  username: '',
  user_email: '',
  higher_uid: "",
  password: "",
  money: "",
  higher_email: "",
  grade_id: -1,
  grade_name: "",
  grade_content: "",
  sell_price: 0,
  wxQR_code: '',
  zfbQR_code: ''
})
var appConf = ref({
  isRenew: false,
  empower_id: -1,
})
var balanceRechargeDialog = ref({
  isShow: false,
  money: "",
  types: [],
  type: "",
  checkType: { min: 0, max: 0 }
})
var deleteAuth_id = -1;
const getTimePrice = computed(() => {
  const product = time_meal_data.value.price * time_meal_data.value.num;
  return product.toFixed(2);
})

var grade_data = reactive<Grade[]>([]);

const select_option = ref()
var empower_data = ref([
  {
    includes_name: '',
    id: "",
    includes_id: "",
    add_date: '',
    empower_host: '',
    higher_uid: "",
    end_date: ""
  },
])
var updateHost_data = ref({
  empower_id: -1,
  update_host: ""
})
var setRemark_data = ref({
  empower_id: -1,
  remark: ""
})
var centerDialog = ref({
  isShow: false,
  title: "info",
  content: "content",
  clickBind: ""
})
var historyDialog = ref({
  isShow: false,
  title: "修改历史记录",
  list: [] as any[]
})
var trendsDialog = ref({
  dialogTitle: "",
  dialogVisible: false
})
var addEmpower_dialog = ref({
  dialogTitle: "",
  dialogVisible: false,
  select_option: "",
  time_Option: [],
  user_email: "",
  host: ""
})
var includes_data = ref({
  select_option: "",
  includes_list: [{
    id: "",
    grade_name: "",
    name: "",
    platform: ""
  }
  ]
})
interface grade_dataIn {
  grade_id: number,
  name: string,
  content: string,
  sell_price: number,
  higher_reward: number,
  isPoss: boolean,
  price_diff: number,
}
var grade_Option = ref<grade_dataIn[]>([]);
const validateUsername = (rule: any, value: any, callback: any) => {
  const regExp = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
  if (regExp.test(value)) {
    callback(new Error('不能有特殊字符'));
  } else {
    callback();
  }
}
const rules = {
  password: [
    { min: 6, max: 20, message: '长度在6-20位', trigger: ['change', 'blur'] },
  ],
  username: [
    { min: 1, max: 10, message: '长度在1-10位', trigger: ['change', 'blur'] },
    { validator: validateUsername, trigger: ['blur', 'change'] },
  ]
}
const userInfo_form = ref(null)
const openDialog = (title: string, content: string, isShow: boolean, clickBind: string) => {
  if (isShow == false) {
    centerDialog.value.isShow = false
  }
  else {
    centerDialog.value.title = title
    centerDialog.value.content = content
    centerDialog.value.isShow = true
    centerDialog.value.clickBind = clickBind
  }
}
const centerDialogClick = (act: string) => {
  switch (act) {
    case "setUserInfo":
      submitForm('setUserInfo');
      break;
    case 'updateHost':
      submitForm('updateHost');
      break;
    case 'setRemark':
      submitForm('setRemark');
      break;
    case 'gradeUp':
      submitForm('gradeUp');
      break;
    case 'addEmpower':
      addEmpowerFun('post');
      break;
    case 'renewEmpower':
      renewEmpowerFun();
      break;
    case 'deleteAuth':
      deleteAuth(deleteAuth_id)
      break;
    default:
      break;
  }
}
const cacheOrigin = (record: any, field: string) => {
  const key = `${field}_origin`
  if (!(key in record)) {
    record[key] = record[field === 'host' ? 'empower_host' : 'remark'] ?? ''
  }
}
const updateHostClick = (record: any) => {
  const origin = record.host_origin ?? ''
  const current = record.empower_host ?? ''
  if (current === origin) return
  record.host_origin = current
  updateHost_data.value.empower_id = record.empower_id
  updateHost_data.value.update_host = current
  openDialog('消息', '您确认要修改此授权吗', true, 'updateHost')
}
const updateRemarkClick = (record: any) => {
  const origin = record.remark_origin ?? ''
  const current = record.remark ?? ''
  if (current === origin) return
  record.remark_origin = current
  setRemark_data.value.empower_id = record.empower_id
  setRemark_data.value.remark = current
  openDialog('消息', '您确认要修改此备注吗', true, 'setRemark')
}
const parseHistory = (historyStr: string | null | undefined) => {
  if (!historyStr) return [];
  try {
    const arr = JSON.parse(historyStr);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}
const openHistoryDialog = (row: any) => {
  const includeName = row.includes_name ? row.includes_name + ' - ' : '';
  historyDialog.value.title = includeName + '修改历史记录';
  historyDialog.value.list = parseHistory(row.modify_history);
  historyDialog.value.isShow = true;
}
const renewAuthDialog = (empower_id: number, includes_id: string, version: number) => {
  appConf.value.isRenew = true;
  addEmpower_dialog.value.dialogVisible = true
  includes_data.value.select_option = includes_id;
  appConf.value.empower_id = empower_id;
  getTimeMeal(includes_id, version + "");

}
const renewEmpowerFun = () => {
  openLoading();
  centerDialog.value.isShow = false
  const headers = {
    'token': localStorage.getItem("token")
  }
  const data = {
    empower_id: appConf.value.empower_id
    , time_act: time_meal_data.value.meal_id
    , time_num: time_meal_data.value.num
  }
  axios.post(baseURL + "/userApi/renewSelfEmpower", data, { timeout: 10000, headers: headers })
    .then(async (res) => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        addEmpower_dialog.value.dialogVisible = false
        message.success(res.data.msg)
        getUserInfo();
      }
      else {
        message.error(res.data.msg)
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      message.error('续费失败：' + err.message)
    })
}
const getUserInfo = () => {
  openLoading()
  const headers = {
    'token': localStorage.getItem("token")
  }
  axios.get(baseURL + "/userApi/getUserInfo", { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      empowerLoading.value = false
      if (res.data.code == 200) {
        user_conf.value = res.data.data
        user_conf.value.higher_email = res.data.data.higher_email
        localStorage.setItem("user_conf", JSON.stringify(user_conf.value))
        empower_data.value = res.data.empower_data;
        empower_Conf.value.total = res.data.total_empower
        empower_Conf.value.disabled = res.data.total_empower < empower_Conf.value.pageSize
      }
      else {
        message.error(res.data.msg)
        if (res.data.code == 401) {
          message.error(res.data.msg)
          setTimeout(() => {
            location.href = "/Login"
          }, 500);
        }
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      empowerLoading.value = false
      console.log(err)
      message.error('获取用户信息失败：' + err.message)
    })
}
const submitForm = (act: string) => {
  openLoading()
  centerDialog.value.isShow = false
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token")
  }
  switch (act) {
    case "setUserInfo":
      if (!user_conf.value.username) {
        fullscreenLoading.close()
        message.error('请输入用户名')
        return
      }
      data.append("act", "setUserInfo");
      if (user_conf.value.password) {
        data.append("password", user_conf.value.password);
      }
      if (user_conf.value.username) {
        data.append("username", user_conf.value.username);
      }
      if (user_conf.value.user_email) {
        data.append("user_email", user_conf.value.user_email);
      }
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            message.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            message.success(res.data.msg)
            getUserInfo();
          }
          else {
            message.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          message.error('请求失败：' + err.message)
        })
      break;
    case "updateHost": {
      const sendUpdateHost = (paid: number) => {
        const hostData = new FormData();
        hostData.append("act", "updateHost");
        if (updateHost_data.value.empower_id && updateHost_data.value.empower_id != -1) {
          hostData.append("empower_id", String(updateHost_data.value.empower_id));
        }
        if (updateHost_data.value.update_host && updateHost_data.value.update_host != "") {
          hostData.append("update_host", updateHost_data.value.update_host);
        }
        if (paid == 1) {
          hostData.append("paid", "1");
        }
        axios.post(baseURL + "/userApi/userSet", hostData, { timeout: 10000, headers: headers })
          .then(res => {
            fullscreenLoading.close()
            if (res.data.code == 401) {
              message.error('您没有登录')
              setTimeout(() => {
                location.href = "/Login"
              }, 1000);
            }
            else if (res.data.code == 4031) {
              const paidPrice = res.data.data ? res.data.data.paid_price : '';
              Modal.confirm({
                title: '付费修改确认',
                content: '免费修改次数已用完，付费修改将扣除 ' + paidPrice + ' 元，是否继续？',
                okText: '确认付费',
                cancelText: '取消',
                okType: 'warning',
                onOk: () => {
                  openLoading()
                  sendUpdateHost(1)
                },
                onCancel: () => undefined
              })
            }
            else if (res.data.code == 200) {
              message.success(res.data.msg)
              getEmpower1();
            }
            else {
              message.error(res.data.msg)
            }
          })
          .catch(err => {
            fullscreenLoading.close()
            console.log(err)
            message.error('请求失败：' + err.message)
          })
      }
      sendUpdateHost(0);
      break;
    }
    case "setRemark": {
      openLoading();
      centerDialog.value.isShow = false
      const remarkPostData = {
        empower_id: setRemark_data.value.empower_id,
        remark: setRemark_data.value.remark
      }
      axios.post(baseURL + "/userApi/setRemark", remarkPostData, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            message.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            message.success(res.data.msg)
            getEmpower1();
          }
          else {
            message.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          message.error('请求失败：' + err.message)
        })
      break;
    }
    case 'gradeUp':
      data.append("act", "gradeUp")
      data.append("grade_id", select_option.value)
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            message.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            message.success(res.data.msg)
            getUserInfo();
          }
          else {
            message.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          message.error('请求失败：' + err.message)
        })
      break;

    default:
      break;
  }
}
const puy_money = () => {
  balanceRechargeDialog.value.isShow = true;
  axios.get(baseURL + "/pay/payType", { timeout: 10000, headers: { 'token': localStorage.getItem("token") } })
    .then(res => {
      if (res.data.code == 200) {
        balanceRechargeDialog.value.types = res.data.data.list
      } else {
        message.error(res.data.msg)
      }
    }).catch(err => {
      console.log(err)
      message.error('请求失败：' + err.message)
    })

}

const payTypeChange = (value: any) => {
  for (let i = 0; i < balanceRechargeDialog.value.types.length; i++) {
    const item = balanceRechargeDialog.value.types[i];
    if (item.type == value) {
      value = item
      break;
    }
  }
  balanceRechargeDialog.value.checkType = value;
}
const store = useStore();
const router = useRouter();
const toRecharge = () => {
  const money = parseInt(balanceRechargeDialog.value.money);
  const min = balanceRechargeDialog.value.checkType.min;
  const max = balanceRechargeDialog.value.checkType.max;
  if (money < min || money > max) {
    message.error('充值金额超出范围：[' + min + ',' + max + ']');
    return;
  }
  openLoading()
  axios.post(baseURL + "/pay/balanceRecharge", {
    name: "余额充值",
    money: balanceRechargeDialog.value.money,
    type: balanceRechargeDialog.value.type
  }, { timeout: 10000, headers: { 'token': localStorage.getItem("token") } })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        balanceRechargeDialog.value.isShow = false;
        const url = res.data.data.url;
        if (!isNull(url)) {
          window.open(res.data.data.url, '_blank');
        } else {
          const outTradeNo = res.data.data.outTradeNo;
          sessionStorage.setItem("outTradeNo", outTradeNo);
          window.open("/alipayDMF", '_blank');
        }
      } else {
        message.error(res.data.msg)
      }
    }).catch(err => {
      fullscreenLoading.close()
      console.log(err)
      message.error('请求失败：' + err.message)
    })
}
const withdrawalView = () => {
  location.href = '/Withdrawal'
}
const handleExceed = (files: any, uploadFiles: any) => {
  message.warning(
    `限制上传一个, 你选择了${files.length} 个文件,`
  )
}
const upload = ref({
  url: baseURL + "/xiaochuFile/uploadImg",
  wx_data: { 'act': 'uploadWxQR', 'token': localStorage.getItem('token') },
  zfb_data: { 'act': 'uploadZfbQR', 'token': localStorage.getItem('token') },
  wx_code: "",
  zfb_code: '',
})
const beforeAvatarUpload = (rawFile: any) => {
  if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png' && rawFile.type !== 'image/gif' && rawFile.type !== 'image/jpg') {
    message.error('只能上传jpeg,png,gif,jp文件')
    return false
  } else if (rawFile.size / 1024 / 1024 > 2) {
    message.error('文件大小不能超过 2MB!')
    return false
  }
  return true
}
const handleWxUploadChange = (info: any) => {
  if (info.file.status === 'done') {
    handleSuccess(info.file.response)
  } else if (info.file.status === 'error') {
    message.error('上传失败')
  }
}
const handleZfbUploadChange = (info: any) => {
  if (info.file.status === 'done') {
    handleSuccess(info.file.response)
  } else if (info.file.status === 'error') {
    message.error('上传失败')
  }
}
const handleSuccess = (response: any) => {
  if (response.code == 200) {
    upload.value.wx_code = ""
    upload.value.zfb_code = ""
    message.success(response.msg)
    if (response.data.includes("zfb_qr")) {
      user_conf.value.zfbQR_code = response.data + "?t=" + Date.now()
    }
    else {
      user_conf.value.wxQR_code = response.data + "?t=" + Date.now()
    }
  }
  else {
    message.error(response.msg)
  }
}
const empower_Conf = ref({
  total: 0,
  pageSize: 10,
  currentPage: 1,
  disabled: false,
})
const empowerLoading = ref(true)
const sizeChange = (val: number) => {
  empower_Conf.value.pageSize = val
  getEmpower1()
}
const currentChange = (val: number) => {
  empower_Conf.value.currentPage = val
  getEmpower1()
}
const pageChange = (page: number, pageSize: number) => {
  empower_Conf.value.currentPage = page
  empower_Conf.value.pageSize = pageSize
  getEmpower1()
}
const getEmpower1 = async () => {
  empowerLoading.value = true
  try {
    const res: EmpowerResponse = await getEmpower(empower_Conf.value.currentPage, empower_Conf.value.pageSize);
    if (res.code == 200) {
      empower_Conf.value.total = res.total_empower
      empower_Conf.value.disabled = res.data.total_empower < empower_Conf.value.pageSize
      empower_data.value = res.data
    }
  } finally {
    empowerLoading.value = false
  }
}
const addEmpowerFun = (act: string) => {
  if (act == 'dialog') {
    appConf.value.isRenew = false;
    addEmpower_dialog.value.dialogVisible = true;
    time_meal_data.value.time_meal_list = [];
    version_data.value.version_list = [];
    version_data.value.select_option = "";

    openLoading();
    const headers = {
      'token': localStorage.getItem("token") || ''
    };

    axios.get(baseURL + "/userApi/getIncludesAll", { timeout: 10000, headers: headers })
      .then(res => {
        fullscreenLoading.close();
        if (res.data.code == 200) {
          includes_data.value.includes_list = res.data.data;
        } else {
          message.error(res.data.msg);
        }
      })
      .catch(err => {
        fullscreenLoading.close();
        console.log(err);
        message.error('获取插件列表失败：' + err.message);
      });
  } else if (act == 'post') {
    openLoading();
    centerDialog.value.isShow = false;
    const headers = {
      'token': localStorage.getItem("token") || ''
    };

    const data = new FormData();
    data.append("includes_id", includes_data.value.select_option);
    data.append("host", addEmpower_dialog.value.host);
    data.append("email", addEmpower_dialog.value.user_email);
    data.append("time_act", time_meal_data.value.meal_id + "");
    data.append("time_num", time_meal_data.value.num + "");

    // Add version if selected
    if (version_data.value.select_option) {
      data.append("version", version_data.value.select_option);
    }

    axios.post(baseURL + "/userApi/addSelfEmpower", data, { timeout: 10000, headers: headers })
      .then(res => {
        fullscreenLoading.close();
        if (res.data.code == 200) {
          addEmpower_dialog.value.dialogVisible = false;
          message.success(res.data.msg);
          getUserInfo(); // Refresh user info after successful authorization
        } else {
          message.error(res.data.msg);
        }
      })
      .catch(err => {
        fullscreenLoading.close();
        console.log(err);
        message.error('添加授权失败：' + err.message);
      });
  }
}

var time_meal_data = ref({
  select_option: "",
  time_meal_list: [
    {
      meal_id: "",
      min: 1,
      max: 1,
      price: 0,
      time_unit: "",
    }
  ],
  num: 1,
  min: 1,
  max: 1,
  unit: "",
  price: 1,
  meal_id: ""
})
var version_data = ref({
  select_option: "",
  version_list: [] as { version: string; versionName: string }[]
})

// Add method to get plugin versions
const getPluginVersions = (soft_id: string) => {
  // Reset version selection and time meal data
  version_data.value.select_option = "";
  version_data.value.version_list = [];
  time_meal_data.value.select_option = "";
  time_meal_data.value.time_meal_list = [];

  // If no plugin selected, return
  if (!soft_id) return;

  openLoading();
  const headers = {
    'token': localStorage.getItem("token") || ''
  };

  const data = {
    soft_id: soft_id
  };

  axios.post(baseURL + "/userApi/getSoftVersion", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close();
      if (res.data.code == 200) {
        version_data.value.version_list = res.data.data.list || [];
        // If there's only one version, auto-select it
        if (res.data.data.list && res.data.data.list.length === 1) {
          version_data.value.select_option = res.data.data.list[0].version;
          onVersionChange(res.data.data.list[0].version);
        }
      } else {
        message.error(res.data.msg || '获取版本信息失败');
      }
    })
    .catch(err => {
      fullscreenLoading.close();
      console.log(err);
      message.error('获取版本信息失败：' + err.message);
    });
}

// Add method to handle version change
const onVersionChange = (version: string) => {
  // Reset time meal selection
  time_meal_data.value.select_option = "";
  time_meal_data.value.time_meal_list = [];

  if (version && includes_data.value.select_option) {
    getTimeMeal(includes_data.value.select_option, version);
  }
}
const getTimeMeal = (includes_id: string, version?: string) => {
  openLoading();
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token") || ''
  };

  data.append("includes_id", includes_id);
  data.append("act", "getTimeMeal");

  // Add version if provided
  if (version) {
    data.append("version", version);
  }

  axios.post(baseURL + "/userApi/getInfo", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close();
      if (res.data.code == 401) {
        message.error('您没有登录');
        setTimeout(() => {
          location.href = "/Login";
        }, 1000);
      } else if (res.data.code == 200) {
        time_meal_data.value.time_meal_list = res.data.data;
      } else {
        message.error(res.data.msg);
      }
    })
    .catch(err => {
      fullscreenLoading.close();
      console.log(err);
      message.error('请求失败：' + err.message);
    });
}
const deleteAuthDialog = (empower_id: number) => {
  deleteAuth_id = empower_id
  openDialog('消息', '您确定要删除此授权吗？此操作不可撤销', true, 'deleteAuth')
}
const deleteAuth = (empower_id: number) => {
  openLoading()
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token")
  }
  data.append("id", empower_id + "")
  axios.post(baseURL + "/userApi/deleteAuth", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      centerDialog.value.isShow = false
      if (res.data.code == 401) {
        message.error('您没有登录')
        setTimeout(() => {
          location.href = "/Login"
        }, 1000);
      }
      else if (res.data.code == 200) {
        message.success(res.data.msg);
        setTimeout(() => {
          getUserInfo()
        }, 200);
      }
      else {
        message.error(res.data.msg)
      }
    })
    .catch(err => {
      centerDialog.value.isShow = false
      fullscreenLoading.close()
      console.log(err)
      message.error('请求失败：' + err.message)
    })
}
const setTimeMeal = (select_option: string) => {
  var element = time_meal_data.value.time_meal_list.filter(item => item.meal_id == select_option);
  time_meal_data.value.num = 1
  time_meal_data.value.min = element[0].min
  time_meal_data.value.max = element[0].max
  time_meal_data.value.unit = element[0].time_unit
  time_meal_data.value.price = element[0].price
  time_meal_data.value.meal_id = element[0].meal_id
}
//计算结束时间还有多久
const getEndDateColor = (end_date: string) => {
  var endDate = new Date(end_date);
  if (endDate.getTime() < new Date().getTime()) {
    return 3;
  }
  if (endDate.getTime() < new Date().getTime() + 1000 * 60 * 60 * 24 * 3) {
    return 2;
  }
  return 1;
}

const getEndDateTagColor = (end_date: string) => {
  const c = getEndDateColor(end_date);
  if (c === 1) return 'green';
  if (c === 2) return 'gold';
  return 'red';
}

// 授权搜索条件
const empowerSearch = reactive({
  keyword: '',
  expireFilter: ''
});

// 行样式（过期行加背景）
const getEmpowerRowClass = (record: any) => {
  const c = getEndDateColor(record.end_date);
  if (c === 3) return 'row-expired';
  if (c === 2) return 'row-warning';
  return '';
};

// 重置搜索
const resetEmpowerSearch = () => {
  empowerSearch.keyword = '';
  empowerSearch.expireFilter = '';
  getEmpower(1);
};

// 前端过滤（如果后端不支持搜索）
const filteredEmpowerData = computed(() => {
  let data = empower_data.value;
  if (!data || data.length === 0) return data;
  if (empowerSearch.keyword) {
    const kw = empowerSearch.keyword.toLowerCase();
    data = data.filter((r: any) =>
      (r.includes_name || '').toLowerCase().includes(kw) ||
      (r.empower_host || '').toLowerCase().includes(kw) ||
      (r.remark || '').toLowerCase().includes(kw)
    );
  }
  if (empowerSearch.expireFilter) {
    data = data.filter((r: any) => {
      const c = getEndDateColor(r.end_date);
      if (empowerSearch.expireFilter === 'normal') return c === 1;
      if (empowerSearch.expireFilter === 'warning') return c === 2;
      if (empowerSearch.expireFilter === 'expired') return c === 3;
      return true;
    });
  }
  return data;
});

// 授权列表列配置
const empowerColumns = [
  { title: '插件信息', key: 'includes_name', width: 150 },
  { title: '插件ID', dataIndex: 'includes_id', key: 'includes_id', width: 70 },
  { title: '添加时间', dataIndex: 'add_date', key: 'add_date', width: 130 },
  { title: '授权字段', key: 'host', width: 180 },
  { title: '授权者ID', dataIndex: 'add_uid', key: 'add_uid', width: 70 },
  { title: '已免费修改', key: 'modify_count', width: 90, align: 'center' },
  { title: '修改历史', key: 'modify_history', width: 80, align: 'center' },
  { title: '到期时间', key: 'end_date', dataIndex: 'end_date', width: 130, align: 'center' },
  { title: '备注', key: 'remark', width: 140 },
  { title: '操作', key: 'action', width: 100, align: 'center' },
];

onMounted(async () => {
  const globalProperties = getCurrentInstance().appContext.config.globalProperties;
  window.ResizeObserver = globalProperties.$customResizeObserver;
  await getUserInfo()
})
</script>
